// MAP_ATTRS_PRS, MAP_ATTRS_IND, MAP_ATTRS_COMP, MAP_ATTRS_ADR, 
export { NAVS_PRS, MAP_ALL_ATTRS_PRS }

const MAP_ATTRS_PRS = {
	id:'ATTRS_PRS',
	navLabel:'sidenav.person.label',
	navIcon:'user',
	instancesClass:{
		prstype: {
			iconClass: 'user',
			// actCol: {actDisplay: true, thCol: '10%', actAdd: false, actGet: true, actEdit: true, actDel: false},
			attrsList: [
				{attrName: 'typeCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'typeName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		prsservice:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'serviceCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'serviceName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		prsfunction:{
			iconClass: 'user',
			attrsList: [
				{attrName: 'functionCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'functionName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		prsteam:{
			iconClass: 'users',
			attrsList: [
				{attrName: 'teamName', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'teamType', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'prsPersonLib', attrCol: '20%', searchable: false, sortable: true},
				{attrName: 'teamTime', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		prsstore:{
			iconClass: 'check-circle',
			attrsList: [
				{attrName: 'storeCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'storeName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},

	}
}

const NAVS_PRS = [MAP_ATTRS_PRS]

const MAP_ALL_ATTRS_PRS = {};
for (let key in MAP_ATTRS_PRS.instancesClass) {
	MAP_ALL_ATTRS_PRS[key]= MAP_ATTRS_PRS.instancesClass[key]
}

